import * as grpcWeb from 'grpc-web';
import { Product, DisplayProduct } from "../components/suppliers/product";
import { convertErrorMessage, getAuthMetadata } from '../helpers/rpc';
import { SportsSouthProduct as SportsSouthProductPb, GetSportsSouthProductRequest } from '../rpc/admin/sportssouth_pb';
import { SearchRequest, Hit, SearchResponse } from '../rpc/admin/search_pb';
import { Supplier } from '../rpc/admin/suppliers_pb';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { getBaseApiUrl } from '../helpers/instance';
import { getUser } from '../helpers/user';
import { logOut } from '../helpers/login';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import React, { Component } from 'react';

interface MatchParams {
    id: string;
}

interface SportsSouthProps {}

interface SportsSouthState {
    product?: DisplayProduct;
    supplierProducts: Hit[];
    errorMessage: string;
}

class SportsSouthProduct extends Component<SportsSouthProps & RouteComponentProps<MatchParams>, SportsSouthState> {

    constructor(props: SportsSouthProps & RouteComponentProps<MatchParams>) {
        super(props);
        this.state = {
            supplierProducts: [],
            errorMessage: ''
        };
    }

    private updateProduct(product: SportsSouthProductPb) {
        const displayProduct = new DisplayProduct();
        displayProduct.supplier = Supplier.SUPPLIER_SPORTS_SOUTH;
        displayProduct.sku = product.getItemno().toString();
        displayProduct.title = product.getIdesc();
        displayProduct.description = product.getText();
        displayProduct.manufacturer = product.getBrand();
        displayProduct.price = product.getCprc() * 100;
        displayProduct.mapp = product.getMfprc() * 100;
        displayProduct.msrp = product.getPrc1() * 100;
        displayProduct.images = product.getImagesList();
        displayProduct.qoh = product.getQtyoh();

        Product.maybeAddStringAttribute(displayProduct, 'UPC', product.getItupc());
        Product.maybeAddStringAttribute(displayProduct, 'Manufacturer Part Number', product.getMfgino());
        Product.maybeAddStringAttribute(displayProduct, 'Model', product.getImodel());
        Product.maybeAddStringAttribute(displayProduct, 'Category', product.getDepartment());
        Product.maybeAddStringAttribute(displayProduct, 'Sub-category', product.getCategory());
        Product.addNumberAttribute(displayProduct, 'Weight (oz)', product.getWtpbx());
        Product.addNumberAttribute(displayProduct, 'Width (in)', product.getWidth());
        Product.addNumberAttribute(displayProduct, 'Height (in)', product.getHeight());
        Product.addNumberAttribute(displayProduct, 'Length (in)', product.getLength());
        product.getAttributesList().forEach((attribute) => {
            Product.maybeAddStringAttribute(displayProduct, attribute.getAttribute(), attribute.getValue());
        });

        this.setState({
            product: displayProduct,
        })
    }

    componentDidMount() {
        if (!getUser()) {
            logOut();
            return;
        }

        let itemnoString: string;
        const id = this.props.match.params.id;
        if (typeof id === 'string') {
            itemnoString = id;
        } else {
            this.setState({
                errorMessage: 'Product not found',
            });
            return;
        }
        const itemno = parseInt(itemnoString);
        if (itemno <= 0 || isNaN(itemno)) {
            this.setState({
                errorMessage: 'Product not found',
            });
            return;
        }

        this.setState({
            errorMessage: '',
        });

        const client = new AdminServiceClient(getBaseApiUrl(), null, null);
        const request = new GetSportsSouthProductRequest();
        request.setItemno(itemno);
        client.getSportsSouthProduct(request, getAuthMetadata(), (err: grpcWeb.Error, response: SportsSouthProductPb) => {
            if (!err) {
                this.updateProduct(response);

                if (response.getItupc()) {
                    const searchRequest = new SearchRequest();
                    searchRequest.setQuery(response.getItupc());
                    client.supplierSearch(searchRequest, getAuthMetadata(), (err: grpcWeb.Error, searchResponse: SearchResponse) => {
                        if (!err) {
                            const hits: Hit[] = [];
                            searchResponse.getHitsList().forEach((hit) => {
                                if (hit.getSupplier() !== Supplier.SUPPLIER_SPORTS_SOUTH) {
                                    hits.push(hit);
                                }
                            });
                            this.setState({
                                supplierProducts: hits,
                            });
                        } else {
                            this.setState({
                                errorMessage: convertErrorMessage(err),
                            });
                            console.error('while searching suppliers: ' + err);
                        }
                    });
                }
            } else {
                if (err.code === grpcWeb.StatusCode.UNAUTHENTICATED || err.code === grpcWeb.StatusCode.PERMISSION_DENIED) {
                    logOut();
                } else {
                    this.setState({
                        errorMessage: convertErrorMessage(err),
                    });
                    console.error(err);
                }
            }
        });
    }


    render() {
        if (!getUser()) {
            return <div>Redirecting...</div>;
        }
        if (this.state.product) {
            const originals = Product.originalImages('suppliers/sports-south', this.state.product.images)
            const images = Product.pruneImages(originals);
            return <Product product={this.state.product}
                images={images}
                errorMessage={this.state.errorMessage}
                supplierProducts= {this.state.supplierProducts}
                imagePrefix='suppliers/sports-south'
                manufacturerFilterPrefix='/sports-south?f=manufacturer' />
        }
        return <></>;
    }
}

export default withRouter(SportsSouthProduct);
